export default `<Route path="/feedback">
  <IndexRoute component={CannyWidget} />
  <Route path="*" component={CannyWidget} />
</Route>`;
